import { GetExtractCategoryQueryAction as GetExtractsQueryAction } from "./GetExtractCategoryQueryAction";
import { GetExtractCategoryQuerySuccessAction as GetExtractsQuerySuccessAction } from "./GetExtractCategoryQuerySuccessAction";
import { GetExtractListAction } from './GetExtractListAction';
import { GetExtractListSuccessAction } from './GetExtractListSuccessAction';
import { FinalizeExtractAction } from './FinalizeExtractAction';
import { FinalizeExtractSuccessAction } from './FinalizeExtractSuccessAction';
import { DeleteExtractAction } from './DeleteExtractAction';
import { DeleteExtractSuccessAction } from './DeleteExtractSuccessAction';
import { GenerateExtractAction } from './GenerateExtractAction';
import { GenerateExtractSuccessAction } from './GenerateExtractSuccessAction';
import { GenerateChildExtractsAction } from './GenerateChildExtractsAction';
import { GenerateChildExtractsSuccessAction } from './GenerateChildExtractsSuccessAction';
import { GetSelectedExtractAction } from './GetSelectedExtractAction';
import { GetSelectedExtractSuccessAction } from './GetSelectedExtractSuccessAction';
import { SetSelectedExtractModelAction } from './SetSelectedExtractModelAction';
import { SetSelectedExtractListModelAction } from './SetSelectedExtractListModelAction';
import { GetSelectedExtractModelAction } from './GetSelectedExtractModelAction';
import { SaveExtractAction } from './SaveExtractAction';
import { SaveExtractSuccessAction } from './SaveExtractSuccessAction';

export type Actions = GetExtractsQueryAction |
                      GetExtractsQuerySuccessAction |
                      GetExtractListAction |
                      GetExtractListSuccessAction |
                      FinalizeExtractAction |
                      FinalizeExtractSuccessAction |
                      DeleteExtractAction |
                      DeleteExtractSuccessAction |
                      GenerateExtractAction |
                      GenerateExtractSuccessAction |
                      GenerateChildExtractsAction |
                      GenerateChildExtractsSuccessAction |
                      GetSelectedExtractAction |
                      GetSelectedExtractSuccessAction |
                      SetSelectedExtractModelAction |
                      SetSelectedExtractListModelAction |
                      GetSelectedExtractModelAction |
                      SaveExtractAction |
                      SaveExtractSuccessAction;

export * from "./GetExtractCategoryQueryAction";
export * from "./GetExtractCategoryQuerySuccessAction";
export * from './GetExtractListAction';
export * from './GetExtractListSuccessAction';
export * from './FinalizeExtractAction';
export * from './FinalizeExtractSuccessAction';
export * from './DeleteExtractAction';
export * from './DeleteExtractSuccessAction';
export * from './GenerateExtractAction';
export * from './GenerateExtractSuccessAction';
export * from './GenerateChildExtractsAction';
export * from './GenerateChildExtractsSuccessAction';
export * from './GetSelectedExtractAction';
export * from './GetSelectedExtractSuccessAction';
export * from './SetSelectedExtractModelAction';
export * from './SetSelectedExtractListModelAction';
export * from './GetSelectedExtractModelAction';
export * from './SaveExtractAction';
export * from './SaveExtractSuccessAction';



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/index.ts